/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectContent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectContent({
  children,
  keepValueUnchanged,
  viewPath = "/DesignSystem/TysiaSelect/TysiaSelectContent",
  backgroundColor,
  borderColor,
  width = "100%",
  size,
  dock,
  disabled,
  focused,
  invalid,
  id,
  from,
  field,
  hovered,
  valid,
  value,
  onBlur,
  onFocus,
  onChange,
  onSubmit,
  allowEmptyChoice,
  placeholder
  
}) {
let dtTysiainputcontentBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.backgroundColor.primary.base'
        })
let dtTysiainputcontentBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.base'
        })
let dtTysiainputcontentBordercolorPrimaryDisabled = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.disabled'
        })
let dtTysiainputcontentBordercolorPrimaryFocused = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.focused'
        })
let dtTysiainputcontentBordercolorPrimaryInvalid = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputContent.borderColor.primary.invalid'
        })
let borderColorOrdtTysiainputcontentBordercolorPrimaryBase = borderColor ?? dtTysiainputcontentBordercolorPrimaryBase
let backgroundColorOrdtTysiainputcontentBackgroundcolorPrimaryBase = backgroundColor ?? dtTysiainputcontentBackgroundcolorPrimaryBase
  return (<React.Fragment
>
<div
  data-testid="TysiaSelectContent.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-Z9txqA': backgroundColorOrdtTysiainputcontentBackgroundcolorPrimaryBase,'--w-9-Z9txqA': typeof width === 'number' ? `${width}px` : width,'--h-7-Z9txqA': size === "small" ? "24px" : "30px",'--pt-8-Z9txqA': size === "small" ? "2px" : "2px",'--bblr-2-Z9txqA': dock === "left" ? "0px" : "4px",'--btlr-4-Z9txqA': dock === "left" ? "0px" : "4px",'--bbrr-3-Z9txqA': dock === "right" ? "0px" : "4px",'--btrr-5-Z9txqA': dock === "right" ? "0px" : "4px",'--bc-6-Z9txqA': disabled ? dtTysiainputcontentBordercolorPrimaryDisabled : focused ? dtTysiainputcontentBordercolorPrimaryFocused : invalid ? dtTysiainputcontentBordercolorPrimaryInvalid : borderColorOrdtTysiainputcontentBordercolorPrimaryBase}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
 id={id}
 from={from}
 size={size}
 dock={dock}
 field={field}
 focused={focused}
 disabled={disabled}
 hovered={hovered}
 invalid={invalid}
 valid={valid}
 value={value}
 onBlur={onBlur}
 onFocus={onFocus}
 onChange={onChange}
 onSubmit={onSubmit}
 allowEmptyChoice={allowEmptyChoice}
 keepValueUnchanged={keepValueUnchanged}
 placeholder={placeholder}
>
{children}
</Children>
</div>
</React.Fragment>)
}